import { h, render } from "preact";
import ProductOptions from "./product-options/product-options";

class ProductFormOptions extends HTMLElement {
  // static observedAttributes = ["product-id"];

  constructor() {
    super();
  }

  connectedCallback() {
    render(
      <ProductOptions
        productId={this.productId}
        idPrefix={this.idPrefix}
        initialVariantId={this.initialVariantId}
        initialVariantHidden={this.initialVariantHidden}
        initialFirstOptionValue={this.initialFirstOptionValue}
        optionsRole={this.optionsRole}
        pillOptions={this.pillOptions}
      />,
      this,
    );
  }

  // attributeChangedCallback(name, oldValue, newValue) {
  //   if (oldValue === newValue) return;

  // }

  get productId() {
    return this.getAttribute("product-id");
  }

  get idPrefix() {
    return this.getAttribute("id-prefix");
  }

  get initialVariantId() {
    return this.getAttribute("initial-variant-id");
  }

  get initialVariantHidden() {
    return this.hasAttribute("initial-variant-hidden");
  }

  get initialFirstOptionValue() {
    return this.getAttribute("initial-first-option-value");
  }

  get optionsRole() {
    return this.getAttribute("options-role");
  }

  get pillOptions() {
    try {
      return JSON.parse(this.getAttribute("pill-options"));
    } catch (error) {
      return [];
    }
  }
}

if (!customElements.get("product-form-options")) {
  customElements.define("product-form-options", ProductFormOptions);
}
